import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
  height: 100%;
  padding: 30px 40px;
  background-color: #FEFEFE;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const TableSearchEvents = styled.form`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 500px;
  height: fit-content;
`; 